import React from 'react';
import './HiringSection.scss';
import soccerCampImg from '../assets/SoccerCamp.png';
import candidatesImg from '../assets/Candidates.png';
import shiftCompleteImg from '../assets/ShiftComplete.png';

const HiringSection = () => {
  return (
    <>
      {/* Stats Section */}
      <section id="stats" className="hiring-section__stats-section scroll-animate fade-in">
        <div className="stats__item scroll-animate fade-up stagger-1">
          <div className="stats__number">25k+</div>
          <div className="stats__label">Athletic Trainers</div>
        </div>
        <div className="stats__item scroll-animate fade-up stagger-2">
          <div className="stats__number">1M</div>
          <div className="stats__label">Hours Posted</div>
        </div>
        <div className="stats__item scroll-animate fade-up stagger-3">
          <div className="stats__number">50</div>
          <div className="stats__label">States Covered</div>
        </div>
      </section>

      <section id="hiring" className="hiring-section scroll-animate fade-in">
        <h2 className="hiring-section__title scroll-animate fade-up stagger-1">Fast, Seamless Hiring</h2>

        <div className="hiring-section__content">
          {/* Step 1 - Post Your Shift */}
          <div className="hiring-section__item scroll-animate slide-left stagger-2">
            <img
              src={soccerCampImg}
              alt="Post Your Shift - Soccer Camp"
              className="hiring-section__mockup-image"
            />
            <div className="hiring-section__step">
              <div className="step__header">
                <span className="step__number">01</span>
                <h3 className="step__title">Post Your Shift</h3>
              </div>
              <p className="step__description">Free & Quick</p>
            </div>
          </div>

          {/* Step 2 - Review Candidates */}
          <div className="hiring-section__item scroll-animate fade-up stagger-3">
            <img src={candidatesImg} alt="Review Candidates" className="hiring-section__mockup-image" />
            <div className="hiring-section__step">
              <div className="step__header">
                <span className="step__number">02</span>
                <h3 className="step__title">Review Candidates</h3>
              </div>
              <p className="step__description">See credentials, insurance, ratings</p>
            </div>
          </div>

          {/* Step 3 - Confirm Coverage */}
          <div className="hiring-section__item scroll-animate slide-right stagger-4">
            <img
              src={shiftCompleteImg}
              alt="Confirm Coverage - Shift Complete"
              className="hiring-section__mockup-image"
            />
            <div className="hiring-section__step">
              <div className="step__header">
                <span className="step__number">03</span>
                <h3 className="step__title">Confirm Coverage</h3>
              </div>
              <p className="step__description">Attendance, EMR, EAPs auto-attached</p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HiringSection;
